import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/es5/util/colors'
import ja from 'vuetify/es5/locale/ja'

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { ja },
        current: 'ja'
    },
    theme: {
        themes: {
            light: {
                primary: colors.blueGrey.darken4,
                edit: colors.green.darken3,
                delete: colors.red.darken2,
                accent: colors.indigo.base,
                info: colors.blue.darken1,
                warning: colors.yellow.base,
                error: colors.red.base,
                success: colors.lightGreen.base,
                secondary: colors.grey.darken1,
            },
        }
    }
});
